const mixin = {
  methods: {
    fixKeyword (keyword) {
      return keyword?.toUpperCase().replace(/\s/g, '')
    }
  }
}


export default mixin
